import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.dashboard.sections.transformationsThisMonth.title',
    defaultMessage: 'Transformations this month',
    description: 'title of the transformations this month section on the dashboard',
  },
};

export default defineMessages(translations);
